/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, NgZone } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { UtilityService } from '../services/utility.service';
import { FirebaseFirestoreService } from '../services/firebase.firestore.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-shopper-root',
  template: `
    <p-toast />
    <p-confirmdialog />
    <div class="bg-green-100 min-h-screen max-w-screen-sm mx-auto">
      <router-outlet />
    </div>
  `,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  standalone: true
})
export class ShopperAppComponent {
  ngZone = inject(NgZone);
  utilityService = inject(UtilityService);
  router = inject(Router);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  userProfile = this.firebaseFirestoreService.getUserProfile();
  constructor() {
    this.subscribeToEvents();
    console.log('ShopperAppComponent constructor');
  }

  subscribeToEvents() {
    this.getDeviceInfo();

    (window as any).onDevicePushToken = (tokenData: any) => {
      const { devicePushToken, permissionStatus } = tokenData;
      console.log(devicePushToken, permissionStatus);
      if (devicePushToken?.data) {
        this.ngZone.run(async () => {
          this.utilityService.notificationsPermissionStatus = permissionStatus;
          this.firebaseFirestoreService.addDeviceFCMToken(this.firebaseFirestoreService.getUserProfile()?.uid as string, devicePushToken);
        });
      }
      this.ngZone.run(() => {
        this.firebaseFirestoreService.updateUserDocument({
          permissions: {
            ...this.firebaseFirestoreService.getUserProfile()?.permissions || {}, notifications: permissionStatus
          }
        });
      })
    }

    (window as any).onPushNotificationClicked = (notificationData: any) => {
      this.ngZone.run(() => {
        // Navigate based on notification data
        if (notificationData?.screen === 'availableBatches' || notificationData?.type === 'new_batch') {
          this.router.navigate([], { queryParams: { tab: 1 , subTab: 0, batchId: notificationData.batchId}, queryParamsHandling: 'merge' });
        }
      })
    }

    (window as any).onCameraPermissionStatus = (permissions: any) => {
      this.ngZone.run(() => {
        this.utilityService.cameraPermissionStatus = permissions;
      })
    }

    (window as any).onNotificationsPermissionStatus = (permissions: any) => {
      this.ngZone.run(() => {
        this.utilityService.notificationsPermissionStatus = permissions;
        this.firebaseFirestoreService.updateUserDocument({permissions: {
          ...this.userProfile?.permissions || {}, notifications: permissions
        }});
      })
    }

    setTimeout(() => {
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-camera-permission-status", data: null}));
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-notifications-permission-status", data: null}));
    }, 500);
  }

  getDeviceInfo() {
    (window as any).onDeviceInfo = (info: any) => {
      this.ngZone.run(() => {
        console.log('onDeviceInfo', info);
        this.utilityService.deviceInfo = info;
      })
    }
    setTimeout(() => {
     (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-device-info", data: null}));
    }, 100);
  }
} 